export const PAGE_ROUTES = [
  { path: '/watcher-links', titleKey: 'header.p.wl' },
];

